<template>
  <div class="registration-modern">
    <div class="hero-section">
      <div class="hero-overlay"></div>
      <div class="container">
        <el-breadcrumb class="breadcrumb">
          <el-breadcrumb-item
            ><span class="breadcrumb_span" @click="backHome"
              >政务服务</span
            ></el-breadcrumb-item
          >
          <el-breadcrumb-item>再生资源备案</el-breadcrumb-item>
        </el-breadcrumb>
        <h1 class="hero-title">再生资源企业备案管理</h1>
        <p class="hero-subtitle">规范行业管理 · 促进循环经济 · 服务企业发展</p>
        <div class="hero-stats">
          <div class="stat-item" v-for="stat in heroStats" :key="stat.id">
            <div class="stat-value">{{ stat.value }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <!-- 主要内容区 -->
      <div class="content-layout">
        <!-- 左侧主内容 -->
        <div class="main-content">
          <!-- 搜索和操作栏 -->
          <el-card shadow="never" class="action-card glassmorph">
            <div class="action-bar">
              <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item>
                  <el-input
                    v-model="searchForm.keyword"
                    placeholder="企业名称/统一信用代码"
                    prefix-icon="el-icon-search"
                    clearable
                    @clear="handleSearch"
                    @keyup.enter.native="handleSearch"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="searchForm.region"
                    placeholder="所在地区"
                    clearable
                    @change="handleSearch"
                  >
                    <el-option
                      v-for="item in regions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="searchForm.status"
                    placeholder="备案状态"
                    clearable
                    @change="handleSearch"
                  >
                    <el-option
                      v-for="item in statusOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="handleSearch"
                    >查询</el-button
                  >
                  <el-button @click="resetSearch">重置</el-button>
                </el-form-item>
              </el-form>
              <div class="action-buttons">
                <el-button
                  type="primary"
                  icon="el-icon-plus"
                  @click="handleCreate"
                >
                  新增备案
                </el-button>
                <el-button icon="el-icon-download" @click="exportData">
                  导出数据
                </el-button>
              </div>
            </div>
          </el-card>

          <!-- 备案企业表格 -->
          <el-card shadow="never" class="table-card glassmorph">
            <el-table
              :data="tableData"
              style="width: 100%"
              v-loading="loading"
              @sort-change="handleSortChange"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                prop="companyName"
                label="企业名称"
                min-width="180"
                sortable
              >
                <template slot-scope="scope">
                  <el-link type="primary" @click="viewDetail(scope.row.id)">{{
                    scope.row.companyName
                  }}</el-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="licenseNumber"
                label="统一信用代码"
                width="180"
              >
              </el-table-column>
              <el-table-column prop="region" label="所在地区" width="120">
              </el-table-column>
              <el-table-column
                prop="legalPerson"
                label="法定代表人"
                width="120"
              >
              </el-table-column>
              <el-table-column prop="contactPhone" label="联系电话" width="130">
              </el-table-column>
              <el-table-column
                prop="registerDate"
                label="备案日期"
                width="120"
                sortable
              >
                <template slot-scope="scope">
                  {{ formatDate(scope.row.registerDate) }}
                </template>
              </el-table-column>
              <el-table-column prop="status" label="备案状态" width="120">
                <template slot-scope="scope">
                  <el-tag
                    :type="getStatusType(scope.row.status)"
                    effect="plain"
                  >
                    {{ getStatusText(scope.row.status) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180" fixed="right">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.row.id)">
                    编辑
                  </el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.row.id)"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagination.current"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagination.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total"
              >
              </el-pagination>
            </div>
          </el-card>
        </div>

        <!-- 右侧边栏 -->
        <div class="sidebar">
          <!-- 备案统计 -->
          <el-card shadow="never" class="stats-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-data-line"></i>
              </div>
              <h2>备案统计</h2>
            </div>

            <div class="stats-content">
              <div class="stat-chart">
                <div id="regionChart" style="width: 100%; height: 200px"></div>
              </div>

              <div class="stats-grid">
                <div class="stat-item" v-for="stat in statsData" :key="stat.id">
                  <div class="stat-value" :style="{ color: stat.color }">
                    {{ stat.value }}
                  </div>
                  <div class="stat-label">{{ stat.label }}</div>
                  <div class="stat-trend" :class="stat.trend">
                    <i :class="stat.trendIcon"></i> {{ stat.trendValue }}
                  </div>
                </div>
              </div>
            </div>
          </el-card>

          <!-- 快速操作 -->
          <el-card shadow="never" class="quick-action-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-thumb"></i>
              </div>
              <h2>快速操作</h2>
            </div>

            <div class="action-grid">
              <div
                class="action-item"
                v-for="action in quickActions"
                :key="action.id"
                @click="handleQuickAction(action.action)"
              >
                <div
                  class="action-icon"
                  :style="{ backgroundColor: action.color }"
                >
                  <i :class="action.icon"></i>
                </div>
                <div class="action-text">{{ action.text }}</div>
              </div>
            </div>
          </el-card>

          <!-- 备案指南 -->
          <el-card shadow="never" class="guide-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-document"></i>
              </div>
              <h2>备案指南</h2>
            </div>

            <div class="guide-list">
              <div
                class="guide-item"
                v-for="guide in guides"
                :key="guide.id"
                @click="downloadGuide(guide.id)"
              >
                <div class="guide-icon">
                  <i :class="guide.icon" :style="{ color: guide.color }"></i>
                </div>
                <div class="guide-content">
                  <div class="guide-title">{{ guide.title }}</div>
                  <div class="guide-desc">{{ guide.desc }}</div>
                </div>
                <i class="el-icon-download"></i>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>

    <!-- 备案表单对话框 -->
    <el-dialog
      :title="formTitle"
      :visible.sync="dialogVisible"
      width="800px"
      custom-class="File-for-record"
      @closed="handleDialogClosed"
    >
      <el-form
        ref="dataForm"
        :model="formData"
        :rules="formRules"
        label-width="120px"
        label-position="right"
      >
        <el-tabs v-model="activeTab">
          <el-tab-pane label="基本信息" name="basic">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="企业名称" prop="companyName">
                  <el-input
                    v-model="formData.companyName"
                    placeholder="请输入企业全称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="统一信用代码" prop="licenseNumber">
                  <el-input
                    v-model="formData.licenseNumber"
                    placeholder="请输入统一社会信用代码"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="法定代表人" prop="legalPerson">
                  <el-input
                    v-model="formData.legalPerson"
                    placeholder="请输入法定代表人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="contactPhone">
                  <el-input
                    v-model="formData.contactPhone"
                    placeholder="请输入联系电话"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="所在地区" prop="region">
                  <el-cascader
                    v-model="formData.region"
                    :options="regions"
                    placeholder="请选择所在地区"
                    style="width: 100%"
                  >
                  </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="详细地址" prop="address">
                  <el-input
                    v-model="formData.address"
                    placeholder="请输入详细地址"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="企业类型" prop="companyType">
                  <el-select
                    v-model="formData.companyType"
                    placeholder="请选择企业类型"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in companyTypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备案日期" prop="registerDate">
                  <el-date-picker
                    v-model="formData.registerDate"
                    type="date"
                    placeholder="选择备案日期"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>

          <el-tab-pane label="经营信息" name="business">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="主营业务" prop="mainBusiness">
                  <el-select
                    v-model="formData.mainBusiness"
                    placeholder="请选择主营业务"
                    multiple
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in businessScopes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="年处理能力" prop="annualCapacity">
                  <el-input
                    v-model="formData.annualCapacity"
                    placeholder="请输入年处理能力"
                  >
                    <template slot="append">吨/年</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="经营场所面积" prop="businessArea">
              <el-input
                v-model="formData.businessArea"
                placeholder="请输入经营场所面积"
              >
                <template slot="append">平方米</template>
              </el-input>
            </el-form-item>

            <el-form-item label="环保设施情况" prop="environmentalFacilities">
              <el-input
                type="textarea"
                :rows="3"
                v-model="formData.environmentalFacilities"
                placeholder="请输入环保设施情况描述"
              >
              </el-input>
            </el-form-item>
          </el-tab-pane>

          <el-tab-pane label="附件资料" name="attachments">
            <el-form-item label="营业执照" prop="businessLicense">
              <el-upload
                action="#"
                list-type="picture-card"
                :file-list="formData.businessLicense"
                :limit="1"
                :on-change="handleLicenseChange"
                :auto-upload="false"
              >
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">
                  上传营业执照扫描件（JPG/PNG格式，不超过5MB）
                </div>
              </el-upload>
            </el-form-item>

            <el-form-item label="备案申请表" prop="applicationForm">
              <el-upload
                action="#"
                :file-list="formData.applicationForm"
                :limit="1"
                :on-change="handleFormChange"
                :auto-upload="false"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  上传已盖章的备案申请表（PDF格式，不超过10MB）
                </div>
              </el-upload>
            </el-form-item>

            <el-form-item label="其他附件" prop="otherAttachments">
              <el-upload
                action="#"
                :file-list="formData.otherAttachments"
                multiple
                :on-change="handleOtherAttachmentsChange"
                :auto-upload="false"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  可上传环保批复、场地证明等其他材料
                </div>
              </el-upload>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {scrollTop} from "@/util/scrollTop";

export default {
  name: 'RegistrationModern',
  data() {
    return {
      loading: false,
      searchForm: {
        keyword: '',
        region: '',
        status: '',
      },
      tableData: [],
      multipleSelection: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      sort: {
        prop: '',
        order: '',
      },
      heroStats: [
        { id: 1, value: '1,258', label: '备案企业总数' },
        { id: 2, value: '326', label: '本年新增备案' },
        { id: 3, value: '98%', label: '合规率' },
      ],
      regions: [
        {
          value: 'zhejiang',
          label: '浙江省',
          children: [
            { value: 'hangzhou', label: '杭州市' },
            { value: 'ningbo', label: '宁波市' },
          ],
        },
        {
          value: 'jiangsu',
          label: '江苏省',
          children: [
            { value: 'nanjing', label: '南京市' },
            { value: 'suzhou', label: '苏州市' },
          ],
        },
      ],
      statusOptions: [
        { value: '1', label: '已备案' },
        { value: '2', label: '备案中' },
        { value: '3', label: '已过期' },
        { value: '4', label: '已注销' },
      ],
      statsData: [
        {
          id: 1,
          value: '326家',
          label: '本年新增',
          trend: 'up',
          trendIcon: 'el-icon-top',
          trendValue: '12.5% ↑',
          color: '#409EFF',
        },
        {
          id: 2,
          value: '85家',
          label: '本月新增',
          trend: 'up',
          trendIcon: 'el-icon-top',
          trendValue: '8.3% ↑',
          color: '#67C23A',
        },
        {
          id: 3,
          value: '92%',
          label: '备案通过率',
          trend: 'up',
          trendIcon: 'el-icon-top',
          trendValue: '2.5% ↑',
          color: '#E6A23C',
        },
        {
          id: 4,
          value: '7天',
          label: '平均处理时间',
          trend: 'down',
          trendIcon: 'el-icon-bottom',
          trendValue: '1.2天 ↓',
          color: '#F56C6C',
        },
      ],
      quickActions: [
        {
          id: 1,
          text: '批量审核',
          icon: 'el-icon-check',
          color: '#409EFF',
          action: 'batch-approve',
        },
        {
          id: 2,
          text: '批量导出',
          icon: 'el-icon-download',
          color: '#67C23A',
          action: 'batch-export',
        },
        {
          id: 3,
          text: '备案统计',
          icon: 'el-icon-data-line',
          color: '#E6A23C',
          action: 'stats',
        },
        {
          id: 4,
          text: '到期提醒',
          icon: 'el-icon-alarm-clock',
          color: '#F56C6C',
          action: 'remind',
        },
      ],
      guides: [
        {
          id: 1,
          title: '备案申请指南',
          desc: '再生资源企业备案申请流程说明',
          icon: 'el-icon-notebook-2',
          color: '#409EFF',
        },
        {
          id: 2,
          title: '材料清单',
          desc: '备案所需材料清单及要求',
          icon: 'el-icon-document-checked',
          color: '#67C23A',
        },
        {
          id: 3,
          title: '常见问题',
          desc: '备案过程中常见问题解答',
          icon: 'el-icon-question',
          color: '#E6A23C',
        },
      ],
      companyTypes: [
        { value: '1', label: '回收企业' },
        { value: '2', label: '加工企业' },
        { value: '3', label: '综合利用企业' },
        { value: '4', label: '全产业链企业' },
      ],
      businessScopes: [
        { value: '1', label: '废金属回收' },
        { value: '2', label: '废纸回收' },
        { value: '3', label: '废塑料回收' },
        { value: '4', label: '废玻璃回收' },
        { value: '5', label: '电子废弃物处理' },
        { value: '6', label: '报废汽车拆解' },
      ],
      dialogVisible: false,
      formTitle: '',
      activeTab: 'basic',
      formData: {
        id: '',
        companyName: '',
        licenseNumber: '',
        legalPerson: '',
        contactPhone: '',
        region: [],
        address: '',
        companyType: '',
        registerDate: '',
        mainBusiness: [],
        annualCapacity: '',
        businessArea: '',
        environmentalFacilities: '',
        businessLicense: [],
        applicationForm: [],
        otherAttachments: [],
        status: '1',
      },
      formRules: {
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
        ],
        licenseNumber: [
          { required: true, message: '请输入统一信用代码', trigger: 'blur' },
          {
            pattern: /^[0-9A-Z]{18}$/,
            message: '统一信用代码格式不正确',
            trigger: 'blur',
          },
        ],
        legalPerson: [
          { required: true, message: '请输入法定代表人', trigger: 'blur' },
        ],
        contactPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur',
          },
        ],
        region: [
          { required: true, message: '请选择所在地区', trigger: 'change' },
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        companyType: [
          { required: true, message: '请选择企业类型', trigger: 'change' },
        ],
        registerDate: [
          { required: true, message: '请选择备案日期', trigger: 'change' },
        ],
        mainBusiness: [
          { required: true, message: '请选择主营业务', trigger: 'change' },
        ],
      },
      regionChart: null,
    };
  },
  mounted() {
    scrollTop()
    this.fetchData();
    this.$nextTick(() => {
      this.initChart();
    });
  },
  methods: {
    fetchData() {
      this.loading = true;
      // 模拟API调用
      setTimeout(() => {
        this.tableData = [
          {
            id: '1',
            companyName: 'XX再生资源回收有限公司',
            licenseNumber: '91310101MA1FPX1234',
            region: '浙江省/杭州市',
            legalPerson: '张三',
            contactPhone: '13800138000',
            registerDate: '2023-05-15',
            status: '1',
          },
          {
            id: '2',
            companyName: 'XX环保科技有限公司',
            licenseNumber: '91310101MA1FPX5678',
            region: '江苏省/南京市',
            legalPerson: '李四',
            contactPhone: '13900139000',
            registerDate: '2023-04-20',
            status: '2',
          },
          {
            id: '3',
            companyName: 'XX废旧物资回收站',
            licenseNumber: '91310101MA1FPX9012',
            region: '浙江省/宁波市',
            legalPerson: '王五',
            contactPhone: '13700137000',
            registerDate: '2023-03-10',
            status: '3',
          },
        ];
        this.pagination.total = 1258;
        this.loading = false;
      }, 500);
    },
    initChart() {
      const chartDom = document.getElementById('regionChart');
      if (chartDom) {
        this.regionChart = echarts.init(chartDom);
        const option = {
          tooltip: {
            trigger: 'item',
          },
          legend: {
            top: '5%',
            left: 'center',
          },
          series: [
            {
              name: '地区分布',
              type: 'pie',
              center: ['50%', '62%'],
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2,
              },
              label: {
                show: false,
                position: 'center',
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '18',
                  fontWeight: 'bold',
                },
              },
              labelLine: {
                show: false,
              },
              data: [
                { value: 584, name: '浙江省' },
                { value: 392, name: '江苏省' },
                { value: 148, name: '上海市' },
                { value: 134, name: '其他地区' },
              ],
              color: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C'],
            },
          ],
        };
        this.regionChart.setOption(option);

        // 响应式调整
        window.addEventListener('resize', () => {
          this.regionChart.resize();
        });
      }
    },
    handleSearch() {
      this.pagination.current = 1;
      this.fetchData();
    },
    resetSearch() {
      this.searchForm = {
        keyword: '',
        region: '',
        status: '',
      };
      this.handleSearch();
    },
    handleSizeChange(val) {
      this.pagination.size = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.fetchData();
    },
    handleSortChange(column) {
      this.sort.prop = column.prop;
      this.sort.order = column.order;
      this.fetchData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCreate() {
      this.formTitle = '新增备案';
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate();
      });
    },
    handleEdit(id) {
      this.formTitle = '编辑备案';
      // 模拟获取详情数据
      const data = this.tableData.find((item) => item.id === id);
      if (data) {
        this.formData = Object.assign({}, data);
        this.dialogVisible = true;
      }
    },
    viewDetail(id) {
      this.$router.push(`/registration/detail/${id}`);
    },
    handleDelete(id) {
      this.$confirm('确认删除该备案信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // 模拟删除操作
          this.$message.success('删除成功');
          this.fetchData();
        })
        .catch(() => {});
    },
    handleDialogClosed() {
      this.formData = {
        id: '',
        companyName: '',
        licenseNumber: '',
        legalPerson: '',
        contactPhone: '',
        region: [],
        address: '',
        companyType: '',
        registerDate: '',
        mainBusiness: [],
        annualCapacity: '',
        businessArea: '',
        environmentalFacilities: '',
        businessLicense: [],
        applicationForm: [],
        otherAttachments: [],
        status: '1',
      };
      this.activeTab = 'basic';
    },
    submitForm() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          // 模拟提交
          this.$message.success(this.formData.id ? '修改成功' : '新增成功');
          this.dialogVisible = false;
          this.fetchData();
        }
      });
    },
    handleQuickAction(action) {
      switch (action) {
        case 'batch-approve':
          if (this.multipleSelection.length === 0) {
            this.$message.warning('请至少选择一条记录');
          } else {
            this.$confirm(
              `确认批量审核选中的 ${this.multipleSelection.length} 条记录吗?`,
              '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              },
            ).then(() => {
              this.$message.success('批量审核成功');
              this.fetchData();
            });
          }
          break;
        case 'batch-export':
          this.exportData(true);
          break;
        case 'stats':
          this.$message.info('查看备案统计');
          break;
        case 'remind':
          this.$message.info('查看到期提醒');
          break;
      }
    },
    exportData(isSelected) {
      if (isSelected && this.multipleSelection.length === 0) {
        this.$message.warning('请至少选择一条记录');
        return;
      }
      this.$message.success('导出数据成功');
    },
    downloadGuide(id) {
      this.$message.success(`开始下载指南ID: ${id}`);
    },
    handleLicenseChange(file, fileList) {
      this.formData.businessLicense = fileList;
    },
    handleFormChange(file, fileList) {
      this.formData.applicationForm = fileList;
    },
    handleOtherAttachmentsChange(file, fileList) {
      this.formData.otherAttachments = fileList;
    },
    formatDate(date) {
      return date ? date.split('-').slice(1).join('-') : '';
    },
    getStatusType(status) {
      const types = {
        1: 'success',
        2: 'primary',
        3: 'warning',
        4: 'info',
      };
      return types[status] || '';
    },
    getStatusText(status) {
      const texts = {
        1: '已备案',
        2: '备案中',
        3: '已过期',
        4: '已注销',
      };
      return texts[status] || '';
    },
    backHome() {
      this.$emit('goBack', '');
    },
  },
  beforeDestroy() {
    if (this.regionChart) {
      this.regionChart.dispose();
    }
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="less" scoped>
/* 备案管理页面主容器样式 */
.registration-modern {
  font-family:
    'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', Arial,
    sans-serif;
  background-color: #f8fafc;
  min-height: 100vh;
}

/* 容器统一宽度 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 英雄区域样式 */
.hero-section {
  background: url('~@/assets/recycling/componyImages/zaishengziyuanbeian.png') center;
  background-size: cover;
  color: white;
  padding: 60px 0 60px;
  position: relative;
  margin-bottom: -40px;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(64, 158, 255, 0.8) 0%,
    rgba(103, 194, 58, 0.6) 100%
  );
  z-index: 0;
}

.hero-section > .container {
  position: relative;
  z-index: 1;
}

/* 面包屑导航样式 */
.breadcrumb /deep/ .el-breadcrumb__item {
  color: rgba(255, 255, 255, 0.8);
}

.breadcrumb /deep/ .el-breadcrumb__item:last-child {
  color: white;
  font-weight: bold;
}

.breadcrumb /deep/ .el-breadcrumb__separator {
  color: rgba(255, 255, 255, 0.6);
}

/* 英雄区域标题样式 */
.hero-title {
  font-size: 36px;
  font-weight: 600;
  margin: 20px 0 10px;
  line-height: 1.2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.hero-subtitle {
  font-size: 18px;
  opacity: 0.9;
  margin: 0 0 30px;
  font-weight: 300;
}

/* 统计数字样式 */
.hero-stats {
  display: flex;
  gap: 30px;
  margin-top: 40px;
}

.stat-item {
  text-align: center;
  flex: 1;
  max-width: 200px;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 8px;
  color: #333;
}

.stat-label {
  font-size: 14px;
  opacity: 0.9;
}

/* 主要内容布局 */
.content-layout {
  display: flex;
  gap: 24px;
  position: relative;
  z-index: 1;
  padding-bottom: 40px;
}

.main-content {
  flex: 1;
  min-width: 0;
}

.sidebar {
  width: 360px;
  flex-shrink: 0;
}

/* 玻璃拟态卡片基础样式 */
.glassmorph {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.glassmorph:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* 卡片头部样式 */
.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-size: 18px;
}

.card-header h2 {
  font-size: 20px;
  margin: 0;
  color: #333;
  flex: 1;
}

/* 操作栏样式 */
.action-bar {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.search-form /deep/ .el-form-item {
  margin-bottom: 0;
}

.search-form /deep/ .el-input__inner {
  height: 40px;
  border-radius: 20px;
  padding-left: 35px;
}

.search-form /deep/ .el-input__prefix {
  left: 10px;
}
/deep/.File-for-record{
  .dialog-footer{
    display: flex;
    justify-content: space-between;
    .el-button {
      z-index: 1;
      width: 50% !important;
    }
  }
}
.action-buttons {
  display: flex;
  gap: 10px;
}

.action-buttons .el-button {
  height: 40px;
  border-radius: 20px;
  padding: 0 20px;
}

/* 表格样式 */
.table-card {
  overflow: hidden;
}

.table-card /deep/ .el-table {
  border-radius: 8px;
  overflow: hidden;
}

.table-card /deep/ .el-table th {
  background-color: #f5f7fa;
  font-weight: 600;
  color: #333;
}

.table-card /deep/ .el-table__row:hover {
  background-color: #f5f7fa;
}

.table-card /deep/ .el-table__cell {
  padding: 12px 0;
}

/* 分页样式 */
.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* 统计卡片样式 */
.stats-content {
  display: flex;
  flex-direction: column;
}

.stat-chart {
  height: 200px;
  margin-bottom: 20px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.stat-item {
  padding: 16px;
  border-radius: 8px;
  background: rgba(250, 250, 252, 0.8);
  text-align: center;
  transition: all 0.3s;
}

.stat-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
}

.stat-trend {
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.breadcrumb_span {
  color: #000000;
  font-weight: 500;
  cursor: pointer;
}

.stat-trend i {
  margin-right: 4px;
}

.stat-trend.up {
  color: #67c23a;
}

.stat-trend.down {
  color: #f56c6c;
}

/* 快速操作区域 */
.action-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  background: rgba(250, 250, 252, 0.8);
}

.action-item:hover {
  background: rgba(64, 158, 255, 0.05);
  transform: translateY(-2px);
}

.action-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  margin-bottom: 10px;
}

.action-text {
  font-size: 14px;
  color: #333;
  text-align: center;
}

/* 备案指南列表 */
.guide-list {
  display: grid;
  gap: 12px;
}

.guide-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  background: rgba(250, 250, 252, 0.8);
}

.guide-item:hover {
  background: rgba(64, 158, 255, 0.05);
  transform: translateX(4px);
}

.guide-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-size: 18px;
  background: rgba(64, 158, 255, 0.1);
}

.guide-content {
  flex: 1;
}

.guide-title {
  font-size: 14px;
  margin-bottom: 4px;
  color: #333;
}

.guide-desc {
  font-size: 12px;
  color: #999;
}

.guide-item .el-icon-download {
  color: #999;
  margin-left: 10px;
  transition: all 0.3s;
}

.guide-item:hover .el-icon-download {
  color: #409eff;
}

/* 对话框样式 */
.el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.el-dialog__header {
  padding: 20px;
  background: linear-gradient(90deg, #409eff, #66b1ff);
}

.el-dialog__title {
  color: #fff;
  font-weight: 500;
}

.el-dialog__headerbtn {
  top: 20px;
}

.el-dialog__body {
  padding: 20px;
}

.el-tabs /deep/ .el-tabs__header {
  margin-bottom: 20px;
}

.el-tabs /deep/ .el-tabs__item {
  font-weight: 500;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-form-item__label {
  font-weight: 500;
  color: #555;
}

.el-input__inner,
.el-textarea__inner,
.el-cascader,
.el-select {
  width: 100%;
}

.el-upload {
  width: 100%;
}

.el-upload--picture-card {
  width: 100%;
  height: 150px;
  line-height: 150px;
  border-radius: 8px;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 100%;
  height: 150px;
  border-radius: 8px;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .content-layout {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
  }

  .action-bar {
    flex-direction: column;
  }

  .search-form {
    width: 100%;
  }

  .action-buttons {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .hero-stats {
    flex-direction: column;
    gap: 20px;
  }

  .stat-item {
    max-width: none;
  }

  .stats-grid,
  .action-grid {
    grid-template-columns: 1fr;
  }

  .el-dialog {
    width: 90% !important;
  }
}

@media (max-width: 480px) {
  .hero-section {
    padding: 60px 0 80px;
  }

  .search-form /deep/ .el-form-item {
    width: 100%;
  }

  .action-buttons {
    justify-content: space-between;
  }

  .action-buttons .el-button {
    flex: 1;
  }
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.action-card,
.table-card,
.stats-card,
.quick-action-card,
.guide-card {
  animation: fadeIn 0.5s ease-out forwards;
}

.action-card {
  animation-delay: 0.1s;
}
.table-card {
  animation-delay: 0.2s;
}
.stats-card {
  animation-delay: 0.3s;
}
.quick-action-card {
  animation-delay: 0.4s;
}
.guide-card {
  animation-delay: 0.5s;
}

/* 状态标签样式 */
.status-tag {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.status-tag.success {
  background-color: rgba(103, 194, 58, 0.1);
  color: #67c23a;
}

.status-tag.primary {
  background-color: rgba(64, 158, 255, 0.1);
  color: #409eff;
}

.status-tag.warning {
  background-color: rgba(230, 162, 60, 0.1);
  color: #e6a23c;
}

.status-tag.info {
  background-color: rgba(144, 147, 153, 0.1);
  color: #909399;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
